import React from "react";
import { Modal } from "react-bootstrap";

const ShopCloseModel = ({ setIsShopIsClosed }) => {
  const [isShow, setIsShow] = React.useState(true);
  const configData = JSON.parse(localStorage.getItem("configData"));
  return (
    <Modal
      show={isShow}
      onHide={() => setIsShow(false)}
      size="lg"
      className="sign-up-modal verification-modal"
    >
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className="verification-page">
          <div className="container">
            <div className="text-content">
              <h2>Notice</h2>
            </div>
            <div className="verification-code">
              <div className="textBoxs" style={{ textAlign: "center" }}>
                <p>{configData?.ShopClosedMessage}</p>
              </div>
            </div>
            <div className="group-btn">
              <button
                title="Continue"
                className="primary-btn sm Continue"
                onClick={() => {
                  setIsShow(false);
                  setIsShopIsClosed(false);
                }}
              >
                OK
                <span>
                  <img src={""} alt="" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShopCloseModel;
